import {
  GET_BLACKLISTS,
  GET_BLACKLISTS_FAIL,
  GET_BLACKLISTS_SUCCESS,
  GET_BLACKLIST_DETAIL,
  ADD_NEW_BLACKLIST,
  ADD_BLACKLIST_SUCCESS,
  ADD_BLACKLIST_FAIL,
  UPDATE_BLACKLIST,
  UPDATE_BLACKLIST_SUCCESS,
  UPDATE_BLACKLIST_FAIL,
  GET_BLACKLIST_DETAIL_FAIL,
  GET_BLACKLIST_DETAIL_SUCCESS,
  CLEAR_MESSAGE,
} from "./actionTypes"

export const getBlacklists = (payload) => ({
  type: GET_BLACKLISTS,
 payload,
})

export const getBlacklistsSuccess = Blacklists => ({
  type: GET_BLACKLISTS_SUCCESS,
  payload: Blacklists,
})

export const addNewBlacklist = Blacklist => ({
  type: ADD_NEW_BLACKLIST,
  payload: Blacklist,
})

export const addBlacklistSuccess = Blacklist => ({
  type: ADD_BLACKLIST_SUCCESS,
  payload: Blacklist,
})

export const addBlacklistFail = error => ({
  type: ADD_BLACKLIST_FAIL,
  payload: error,
})

export const updateBlacklist = Blacklist => ({
  type: UPDATE_BLACKLIST,
  payload: Blacklist,
})

export const updateBlacklistSuccess = Blacklist => ({
  type: UPDATE_BLACKLIST_SUCCESS,
  payload: Blacklist,
})

export const updateBlacklistFail = error => ({
  type: UPDATE_BLACKLIST_FAIL,
  payload: error,
})

export const getBlacklistsFail = error => ({
  type: GET_BLACKLISTS_FAIL,
  payload: error,
})

export const getBlacklistDetail = BlacklistId => ({
  type: GET_BLACKLIST_DETAIL,
  BlacklistId,
})

export const getBlacklistDetailSuccess = BlacklistDetails => ({
  type: GET_BLACKLIST_DETAIL_SUCCESS,
  payload: BlacklistDetails,
})

export const getBlacklistDetailFail = error => ({
  type: GET_BLACKLIST_DETAIL_FAIL,
  payload: error,
})

export const clearMessage = () => ({
  type: CLEAR_MESSAGE,
})
